import type { FC } from 'react';
import { Fragment, Suspense, useCallback, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { DrawerMenu, LinearProgress } from 'components/fragment';
import ContactSupportModal from 'components/modals/ContactSupportModal/ContactSupportModal';

/**
 * Event listener wiring:
 *
 *  DrawerMenu "Contact Support" click
 *       │
 *       ▼
 *  window.dispatchEvent(CustomEvent('open-contact-support'))
 *       │
 *       ▼
 *  MainLayout useEffect listener → setContactSupportOpen(true)
 *       │
 *       ▼
 *  <ContactSupportModal open={true} />
 */
const MainLayout: FC = () => {
  const location = useLocation();
  const [contactSupportOpen, setContactSupportOpen] = useState(false);

  const handleOpenContactSupport = useCallback(() => {
    setContactSupportOpen(true);
  }, []);

  useEffect(() => {
    window.addEventListener('open-contact-support', handleOpenContactSupport);
    return () => {
      window.removeEventListener('open-contact-support', handleOpenContactSupport);
    };
  }, [handleOpenContactSupport]);

  return (
    <Fragment>
      <Suspense fallback={<LinearProgress />}>
        <DrawerMenu />
        <Outlet key={location.key} />
      </Suspense>
      <ContactSupportModal
        open={contactSupportOpen}
        onClose={() => setContactSupportOpen(false)}
      />
    </Fragment>
  );
};
export default MainLayout;
